import { useTranslation } from 'react-i18next';
import { SEO } from '../seo/SEO';

const SECTIONS = ['scope', 'appointments', 'payment', 'cancellation', 'privacy', 'liability'] as const;

export function TermsPage() {
  const { t } = useTranslation();

  return (
    <section className="max-w-editorial mx-auto px-6 sm:px-10 py-20">
      <SEO titleKey="seo.terms.title" descriptionKey="seo.terms.description" />
      <div className="grid grid-cols-12 gap-8 mb-16 border-b border-linen pb-12">
        <div className="col-span-12 md:col-span-3">
          <span className="editorial-number text-5xl block">N°04</span>
          <div className="editorial-label mt-3">— Maison</div>
        </div>
        <div className="col-span-12 md:col-span-9">
          <h1 className="font-display text-[clamp(2.5rem,5vw,4.5rem)] leading-[0.95]">
            {t('terms.title')}
          </h1>
          <p className="mt-6 editorial-label">{t('terms.updated', { date: '2026-01-01' })}</p>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-9 md:col-start-4 space-y-16">
          {SECTIONS.map((key, i) => (
            <article key={key} className="grid grid-cols-12 gap-6">
              <div className="col-span-12 md:col-span-2">
                <span className="editorial-number text-3xl italic">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="col-span-12 md:col-span-10">
                <h2 className="font-display text-3xl italic mb-4">
                  {t(`terms.sections.${key}.title`)}
                </h2>
                <p className="font-body text-base text-ink-soft leading-relaxed">
                  {t(`terms.sections.${key}.body`)}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
